import { render } from "./CurriculumVitae.vue?vue&type=template&id=7b03f32e&scoped=true"
import script from "./CurriculumVitae.vue?vue&type=script&lang=js"
export * from "./CurriculumVitae.vue?vue&type=script&lang=js"

import "./CurriculumVitae.vue?vue&type=style&index=0&id=7b03f32e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b03f32e"]])

export default __exports__